import { useIntl } from "react-intl";

import { LoggedOutConfluenceBlueWaveTemplate } from "../../components/logged-out-confluence-blue-wave-template";

export const LoggedOutConfluencePremium = () => {
    const { formatMessage } = useIntl();

    return (
        <LoggedOutConfluenceBlueWaveTemplate
            productEditionText={formatMessage({
                id: "WacSignupHeader.cloudPremium",
                defaultMessage: "Cloud Premium"
            })}
        />
    );
};
